const ids = {
  ua: {
    multibrand: 'UA-21174015-74',
    zrm: 'UA-21174015-56',
    hp: 'UA-161502-10',
  },
  dsp: {
    prod: 'dsp-z_prod',
    dev: 'dsp-z_test',
  },
  gtm: {
    prod: 'GTM-P6HT97',
    dev: 'GTM-WTRMC7',
  },
  comscore: {
    prod: 'COM-6036206',
    dev: 'COM-0000000',
  },
  native: 'native',
};

const names = {
  [ids.ua.multibrand]: 'uaMultibrand',
  [ids.ua.zrm]: 'uaZrm',
  [ids.ua.hp]: 'uaHp',
  [ids.gtm.prod]: 'gtmProd',
  [ids.gtm.dev]: 'gtmDev',
};

export default {
  ids,
  names,
};
